import types from '../actions/types';

export const emptyApplicant = {
  name: '',
  lastName: '',
  motherLastName: '', // TODO: Revisar si "Apellido materno" queda como campo
  nationality: '',
  documentType: null,
  documentNumber: '',
  mobileNumber: '',
  phoneNumber: '', // TODO: Revisar si el campo "Teléfono fijo" queda como campo
  email: '',
  dateOfBirth: '',
  gender: null, // NOTE: Ejemplo, { label: 'Masculino', value: 'M' }
  civilStatus: null, // NOTE: Ejemplo, { label: 'Soltero/a', value: 'S' }
  addressState: null,
  addressCity: null,
  addressStreet: null,
  addressNumber: '',
  addressApto: '',

  // Labor Data
  occupation: null,
  workActivity: '',
  jobTitle: '',
  jobYears: '', // NOTE: En años
  jobNetPay: '',
  jobNetPayCurrency: false, // NOTE: false: UYU, true USD.

  companyName: '',
  companyRUT: '',

  // Misc
  knowUs: null,
  clientEmail: '', // TODO: No se usa
  confidenceBroker: null,
  // confidenceBrokerName: '',

  workAddressState: null,
  workAddressCity: null,
  workAddressStreet: null,
  workAddressNumber: '',
  workAddressApto: ''
};

const initialState = {
  amount: '',
  isCompany: false,
  currencyCode: false, // NOTE: false: UYU, true USD.

  fixedAmount: '',
  fixedCurrencyCode: false,

  prize: 0,
  prize6: 0,
  prize10: 0,
  minSalary: 0,

  finished: false,
  finishedStatus: { error: true, message: '' },

  applicants: [
    { ...emptyApplicant }
  ],

  // Property
  knownRealEstate: false,
  knownPropertyLocation: false,
  knownPropertyLocationText: '',
  monthlyRentalAmount: '', // NOTE: Same as "amount"
  monthlyRentalAmountCurrency: false, // NOTE: false: UYU, true USD. (same as "currencyCode")

  // Attachments
  attachments: []
};

const cleanableState = {
  applicants: [
    { ...emptyApplicant }
  ]
};

// const cleanableState = {
//   amount: '',
//   isCompany: false,
//   currencyCode: false, // NOTE: false: UYU, true USD.

//   fixedAmount: '',
//   fixedCurrencyCode: false,

//   prize: 0,
//   prize6: 0,
//   prize10: 0,
//   minSalary: 0,

//   finished: false,
//   finishedStatus: { error: true, message: '' },

//   applicants: [
//     { ...emptyApplicant }
//   ],

//   // Property
//   knownRealEstate: false,
//   knownPropertyLocation: false,
//   knownPropertyLocationText: '',
//   monthlyRentalAmount: '', // NOTE: Same as "amount"
//   monthlyRentalAmountCurrency: false, // NOTE: false: UYU, true USD. (same as "currencyCode")

//   // Attachments
//   attachments: []
// };

const rental = (state = {...initialState, ...cleanableState}, action) => {
  switch (action.type) {

    case types.CLEAN: {
      return { ...initialState, applicants: [ {...emptyApplicant} ]};
    }

    case types.SET_RENTAL_VALUE: {
      const { type, value } = action.payload;
      return {
        ...state,
        [type]: value
      }
    };

    default:
      return state;
  }
};

export default rental;
